module.exports = __webpack_public_path__ + "da0e9bed91e8a4754bf1109db84d8f78.svg";